/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-no-comment-textnodes */
import React, { Fragment, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col, Image } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { Waypoint } from "react-waypoint";
import OpcionesServiciosComponent from "../opcionesServicios";
import EncabezadoComponent from "../../../utilerias/encabezado";
import LightboxComponent from "../lightBox";
import "react-image-lightbox/style.css";
import $ from "jquery";
import "./styles.css";

const BannerComponent = (props) => {
  const [lightOpen, guardarLigthOpen] = useState(false);
  const [posicion1, guardarPosicion1] = useState();
  const [posicion2, guardarPosicion2] = useState();
  const [serviciosOpciones] = useState(props.servicios);

  const handleWaypointEnter = (idIcono, id) => {
    const iconoServicio = document.getElementById(idIcono);
    iconoServicio.classList = "icono-nav-activo";
    const x = window.matchMedia("(max-width: 999px)");
    const nombreServicio = document.getElementById("nombre-servicio-" + id);
    const nombreDescripcion = document.getElementById(
      "servicio-descripcion-" + id
    );
    if (nombreServicio) {
      nombreServicio.style.opacity = "1";
      nombreDescripcion.style.opacity = "1";
      const busquedaId = document.getElementById("carga-" + id);
      const busquedaClase = busquedaId.getElementsByClassName("carga");
      const imgDesenfoque = document.getElementById("box-" + id);
      if (x.matches === true) {
        busquedaClase[0].style.height = "40vh";
      } else {
        busquedaClase[0].style.height = "58vh";
      }
      imgDesenfoque.style.height = "60vh";
      const distorcion = busquedaClase[0].getElementsByClassName(
        "img-distorcion"
      );
      setTimeout(function () {
        distorcion[0].style.transition = "0.8s";
        distorcion[0].style.opacity = "0";
      }, 800);
    }
  };

  const handleWaypointLeave = (idIcono, id) => {
    const iconoServicio = document.getElementById(idIcono);
    iconoServicio.classList = "";
    const x = window.matchMedia("(max-width: 999px)");
    const nombreServicio = document.getElementById("nombre-servicio-" + id);
    const nombreDescripcion = document.getElementById(
      "servicio-descripcion-" + id
    );
    if (nombreServicio) {
      nombreServicio.style.opacity = "0";
      nombreDescripcion.style.opacity = "0";
      const busquedaId = document.getElementById("carga-" + id);
      const busquedaClase = busquedaId.getElementsByClassName("carga");
      const imgDesenfoque = document.getElementById("box-" + id);
      if (x.matches === true) {
        busquedaClase[0].style.height = "0vh";
      } else {
        busquedaClase[0].style.height = "0vh";
      }
      imgDesenfoque.style.height = "60vh";
      const distorcion = busquedaClase[0].getElementsByClassName(
        "img-distorcion"
      );
      setTimeout(function () {
        distorcion[0].style.transition = "0.8s";
        distorcion[0].style.opacity = "0";
      }, 800);
    }
  };

  useEffect(() => {
    investirScroll();
  }, []);

  const investirScroll = () => {
    const scroller = {};
    const x = window.matchMedia("(min-width: 1025px)");
    const scrollSMiniPc = window.matchMedia("(max-width: 1300px)");
    const scrollMiniPc = window.matchMedia("(max-width: 1450px)");
    const scrollMdPc = window.matchMedia("(max-width: 1620px)");
    if (x.matches === true) {
      scroller.e = document.getElementById("invertir-scroll");

      if (scroller.e.addEventListener) {
        scroller.e.addEventListener("mousewheel", MouseWheelHandler, false);
        scroller.e.addEventListener("DOMMouseScroll", MouseWheelHandler, false);
      } else scroller.e.attachEvent("onmousewheel", MouseWheelHandler);

      function MouseWheelHandler(e) {
        // cross-browser wheel delta
        const sc = window.event || e
        let delta;
        if (scrollSMiniPc.matches === true) {
          delta =
            -1320 * Math.max(-1, Math.min(1, sc.wheelDelta || -sc.detail));
        } else if (scrollMiniPc.matches === true) {
          delta =
            -1500 * Math.max(-1, Math.min(1, sc.wheelDelta || -sc.detail));
        } else if (scrollMdPc.matches === true) {
          delta =
            -1650 * Math.max(-1, Math.min(1, sc.wheelDelta || -sc.detail));
        } else {
          delta =
            -2000 * Math.max(-1, Math.min(1, sc.wheelDelta || -sc.detail));
        }

        let pst = $("#invertir-scroll").scrollLeft() + delta;
        if (pst < 0) {
          pst = 0;
        } else if (pst > $("#slider").width()) {
          pst = $("#slider").width();
        }

        $("#invertir-scroll").scrollLeft(pst);

        return false;
      }
    }
  };

  const lightbox = (posicion1, posicion2) => {
    if (lightOpen) {
      guardarLigthOpen(false);
    } else {
      guardarLigthOpen(true);
      guardarPosicion1(posicion1);
      guardarPosicion2(posicion2);
    }
  };

  // console.log(props.servicios);
  return (
    <Fragment>
      <Container
        id="invertir-scroll"
        fluid
        className="contenedor-principal-servicios"
      >
        <Row>
          <Col className="encabezado-servicios" md={ 12 } lg={ 12 } align="center">
            <EncabezadoComponent
              componente={ props.componente }
              select={ false }
            ></EncabezadoComponent>
          </Col>
        </Row>
        <div className="contenedor-scroll">
          <LightboxComponent
            lightbox={ lightbox }
            isOpen={ lightOpen }
            posicion1={ posicion1 }
            posicion2={ posicion2 }
          ></LightboxComponent>
          <div id="slider">
            { props.servicios.map((index, i) => {
              return props.servicios[i].servicios.map((index, j) => {
                return (
                  <Fragment key={ j }>
                    <Row
                      id={ props.servicios[i].servicios[j].idAncla }
                      className="servicio-contenedor"
                    >
                      <Col md={ 12 } lg={ 2 } align="center"></Col>
                      <Col
                        className="col-img-servicio"
                        md={ 12 }
                        lg={ 4 }
                        align="center"
                      >
                        <Waypoint
                          onEnter={ () =>
                            handleWaypointEnter(
                              props.servicios[i].servicios[j].idAncla +
                              "-" +
                              props.servicios[i].servicios[j].id,
                              props.servicios[i].servicios[j].idAncla
                            )
                          }
                          horizontal={ true }
                        />
                        {/* <Waypoint
                          onLeave={ () =>
                            handleWaypointEnter(
                              props.servicios[i].servicios[j].idAncla +
                              "-" +
                              props.servicios[i].servicios[j].id,
                              props.servicios[i].servicios[j].idAncla
                            )
                          }
                          horizontal={ true }
                        /> */}
                        <div
                          id="img-contenedor-secundaria"
                          className="contenedor-imagen-desenfoque"
                        >
                          <div
                            id={
                              "box-" + props.servicios[i].servicios[j].idAncla
                            }
                            className="box"
                          >
                            <Image
                              id="img-secundaria"
                              src={ props.servicios[i].servicios[j].imagen }
                              className="img-blur"
                            />
                          </div>
                        </div>
                        <div
                          id={
                            "carga-" + props.servicios[i].servicios[j].idAncla
                          }
                          className="imagenes-contenedor"
                        >
                          <div id="content" className="carga">
                            <div
                              id="img-servicio-contenedor"
                              className="doc-servicios"
                            >
                              <div className="box">
                                <Image
                                  id="img-principal"
                                  src={ props.servicios[i].servicios[j].imagen }
                                />
                              </div>
                              <div className="ver-mas-contenedor">+</div>
                            </div>
                            <div className="imagen-distoricionada">
                              <div className="box-distorcion">
                                <Image
                                  className="img-distorcion"
                                  src="/assets/servicios/gris.gif"
                                  onClick={ () => lightbox(i, j) }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                        <Waypoint
                          onLeave={ () =>
                            handleWaypointLeave(
                              props.servicios[i].servicios[j].idAncla +
                              "-" +
                              props.servicios[i].servicios[j].id,
                              props.servicios[i].servicios[j].idAncla
                            )
                          }
                          horizontal={ true }
                        />
                      </Col>
                      <Col md={ 12 } lg={ 1 } align="center"></Col>
                      <Col
                        className="col-servicios-info"
                        md={ 12 }
                        lg={ 3 }
                        align="center"
                      >
                        <div></div>
                        <div></div>
                        <div className="servicios-titulo">
                          <div>
                            <b
                              id={
                                "nombre-servicio-" +
                                props.servicios[i].servicios[j].idAncla
                              }
                              className="nombre-servicio"
                            >
                              { props.servicios[i].servicios[j].nombre }
                            </b>
                          </div>
                        </div>
                        <div
                          id={
                            "servicio-descripcion-" +
                            props.servicios[i].servicios[j].idAncla
                          }
                          className="servicio-descripcion"
                        >
                          { props.servicios[i].servicios[j].descripcion }
                        </div>
                        <div></div>
                      </Col>
                      <Col md={ 12 } lg={ 2 } align="center"></Col>
                    </Row>
                  </Fragment>
                );
              });
            }) }
          </div>
        </div>
        <div className="nav-contenedor-principal">
          { props.servicios.map((index, i) => {
            return props.servicios[i].servicios.map((index, j) => {
              return (
                <OpcionesServiciosComponent
                  key={ j }
                  cambiar={ serviciosOpciones[i].servicios[j] }
                ></OpcionesServiciosComponent>
              );
            });
          }) }
        </div>
      </Container>
    </Fragment>
  );
};

BannerComponent.propTypes = {
  servicios: PropTypes.array,
  idiomaNavegador: PropTypes.string,
  componente: PropTypes.string,
};

export default BannerComponent;
